import { render } from "./ProspectLabel.vue?vue&type=template&id=6129b5c6"
import script from "./ProspectLabel.vue?vue&type=script&lang=js"
export * from "./ProspectLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__